import { PermissionService } from '../services/permission.service';
import { RolePermissionObjects } from '../shared/constants/rolePermissionObjects.constants';
import { GridPermissions, gridToPermissionFlags } from '../shared/grid/core-grid/gridPermissions.enum';

// The SEG org-level association endpoints (BulkAddSegOrgLevels / BulkPatch / Delete) authorize
// each operation independently against GLOBAL_Seg_OrgLevel — an add needs Create, an edit Update,
// a removal Delete. Roles such as Teck's 'Site Admin - IH' hold GLOBAL_Seg_OrgLevel while
// GLOBAL_SEG is read-only, so the org-level affordances must honour this permission alongside the
// GLOBAL_SEG gate. A *registered* permission is required (not the fail-open path) so an
// unregistered objectId falls back to the GLOBAL_SEG gate at the call site rather than exposing
// the action to everyone.
export function hasSegOrgLevelPermission(
  permissionService: PermissionService,
  action: GridPermissions,
): boolean {
  const permission = permissionService.getRolePermission(RolePermissionObjects.SegOrgLevel);
  return !!permission && !!(permission.permissions & gridToPermissionFlags[action]);
}
